/* ==============================================
   SUR-MESURE FYRRE x MAISON DES RIDEAUX - GLOBAL
   ============================================== */

function setupSurMesure() {
  document.querySelectorAll('#custom-size-block').forEach(block => {
    if (block.dataset.bound === 'true') return; // éviter doublons
    block.dataset.bound = 'true';

    const sectionEl = block.closest('[id^="Product-"]');
    const addonVariantId = block.dataset.addonVariantId;
    const widthInput = block.querySelector('#customWidth');
    const heightInput = block.querySelector('#customHeight');
    const statusEl = block.querySelector('.custom-size__status');
    const radios = block.querySelectorAll('input[name="sizeMode"]');
    const inputsWrap = block.querySelector('.custom-size__inputs');

    if (!sectionEl || !widthInput || !heightInput) return;

    /* ---------- Parsing utilitaire ---------- */
    function cleanTxt(s) {
      return String(s || '')
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/cm/g, '')
        .replace(/×/g, 'x')
        .replace(',', '.');
    }

    function extractDimsFromVariant(v) {
      const o1 = cleanTxt(v.option1);
      const o2 = cleanTxt(v.option2);
      const o3 = cleanTxt(v.option3);
      const arr = [o1, o2, o3].filter(Boolean);

      // cas "100x250"
      const combined = arr.find(t => t.includes('x'));
      if (combined) {
        const [wStr, hStr] = combined.split('x');
        return { w: parseFloat(wStr) || 0, h: parseFloat(hStr) || 0 };
      }

      // cas deux valeurs séparées
      const nums = arr
        .map(t => parseFloat(t))
        .filter(n => Number.isFinite(n) && n > 0);
      if (nums.length >= 2) return { w: nums[0], h: nums[1] };

      return { w: 0, h: 0 };
    }

    /* ---------- Récupération des variantes ---------- */
    const productDataEl = document.querySelector('#ProductDataJSON');
    const productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;

    const variants = (productData?.variants || [])
      .map(v => {
        const { w, h } = extractDimsFromVariant(v);
        return {
          id: v.id,
          available: v.available,
          width: w,
          height: h,
          price: v.price
        };
      })
      .filter(v => v.available && v.width > 0 && v.height > 0);

    console.table(variants.map(v => ({ id: v.id, width: v.width, height: v.height })));

    /* ---------- Fonctions de recherche ---------- */
    function findExactVariant(w, h) {
      return variants.find(v => v.width === w && v.height === h) || null;
    }

    function findCeilingVariant(w, h) {
      const c = variants.filter(v => v.width >= w && v.height >= h);
      if (!c.length) return null;
      c.sort((a, b) => (a.width - b.width) || (a.height - b.height));
      return c[0];
    }

    /* ---------- Gestion du mode ---------- */
    function setMode(mode) {
      inputsWrap.style.display = mode === 'custom' ? 'block' : 'none';
      statusEl.textContent = '';
    }
    radios.forEach(r => r.addEventListener('change', () => setMode(r.value)));
    [widthInput, heightInput].forEach(i => {
      i.addEventListener('input', () => {
        i.value = i.value.replace(/[^0-9\.,]/g, '');
      });
    });

    /* ---------- Ouverture du cart drawer (multi-fallback) ---------- */
    function openCartDrawerFallback() {
      // 1) APIs internes connues (selon thèmes)
      const openFn =
        (window.Purity && window.Purity.Cart && window.Purity.Cart.open) ||
        (window.Shopify && window.Shopify.theme && window.Shopify.theme.cartDrawer && window.Shopify.theme.cartDrawer.open) ||
        (window.CartDrawer && window.CartDrawer.open) ||
        (window.theme && window.theme.Cart && window.theme.Cart.open);

      if (typeof openFn === 'function') {
        try { openFn(); return true; } catch (_) {}
      }

      // 2) Simuler un clic sur les triggers usuels
      const triggers = [
        '[data-action="toggle-cart"]',
        '[data-cart-open]',
        '[data-button="cart"], [data-button="open-cart"]',
        '.header__cart',
        'button[aria-controls*="cart"], a[aria-controls*="cart"]',
        '.cart-toggle, .js-cart-toggle'
      ];
      for (const sel of triggers) {
        const btn = document.querySelector(sel);
        if (btn) { btn.click(); return true; }
      }

      // 3) Forcer l’ouverture sur conteneurs connus
      const drawers = document.querySelectorAll('.cart-drawer, [data-cart-drawer], .drawer--cart, #CartDrawer');
      if (drawers.length) {
        drawers.forEach(el => {
          el.classList.add('is-open', 'open', 'active');
          el.setAttribute('aria-hidden', 'false');
          el.style.display = 'block';
        });
        document.documentElement.classList.add('no-scroll', 'drawer-open');
        return true;
      }

      return false;
    }

    function refreshCartUI() {
      // Émettre des événements potentiels écoutés par des thèmes
      const candidates = ['cart:updated', 'cart:update', 'theme:cart:refresh', 'cart-drawer:open'];
      candidates.forEach(ev => {
        try { document.dispatchEvent(new CustomEvent(ev, { detail: { source: 'surmesure' } })); } catch (_) {}
      });
      // Puis tenter l’ouverture
      openCartDrawerFallback();
    }

    /* ---------- Handler d'ajout ---------- */
    function handleAdd(scopeEl, evtLabel) {
      const mode = block.querySelector('input[name="sizeMode"]:checked')?.value || 'standard';
      if (mode === 'standard') return false;

      const w = parseFloat(widthInput.value.replace(',', '.'));
      const h = parseFloat(heightInput.value.replace(',', '.'));
      if (!w || !h || w <= 0 || h <= 0) {
        statusEl.textContent = 'Renseignez une largeur et une hauteur valides.';
        return true;
      }

      const exact = findExactVariant(w, h);
      const target = exact || findCeilingVariant(w, h);
      if (!target) {
        statusEl.textContent = 'Ces dimensions dépassent nos tailles disponibles.';
        return true;
      }

      const needAddon = !exact && (w < target.width || h < target.height);

      const variantInput = scopeEl.querySelector('[name="id"]');
      if (variantInput) {
        variantInput.value = String(target.id);
      }

      const qty = parseInt(scopeEl.querySelector('[name="quantity"]')?.value || 1, 10);
      const properties = {
        type_de_commande: needAddon ? 'surmesure' : 'standard',
        largeur_cm: String(widthInput.value),
        hauteur_cm: String(heightInput.value),
        taille_reference: `${target.width}x${target.height}`
      };

      const items = [{ id: target.id, quantity: qty, properties }];

      if (needAddon && addonVariantId) {
        items.push({
          id: Number(addonVariantId),
          quantity: qty,
          properties: {
            linked_to_variant_id: String(target.id),
            custom_addon: 'surmesure'
          }
        });
      }

      console.log('[Surmesure] add', { evtLabel, target, exact, needAddon, w, h, qty, items });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(r => r.json())
        .then(data => {
          console.log('[Surmesure] ajouté avec succès', data);
          refreshCartUI(); // ← ouvrir le drawer (sans redirection)
        })
        .catch(() => (statusEl.textContent = 'Erreur. Réessayez.'));

      return true;
    }

    /* ---------- Interceptions ---------- */
    sectionEl.querySelectorAll('form').forEach(form => {
      form.addEventListener(
        'submit',
        e => {
          const intercepted = handleAdd(form, 'submit');
          if (intercepted) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    });

    sectionEl.addEventListener(
      'click',
      e => {
        const btn = e.target.closest('button, a, input[type="submit"]');
        if (!btn) return;
        const isAdd =
          btn.name === 'add' ||
          btn.type === 'submit' ||
          btn.getAttribute('data-action') === 'add-to-cart' ||
          btn.classList.contains('product-form__submit') ||
          btn.classList.contains('sticky-add-cart__button') ||
          btn.matches('[data-add-to-cart], [data-button="add-to-cart"]');
        if (!isAdd) return;

        const scope = btn.closest('form') || sectionEl;
        const intercepted = handleAdd(scope, 'click');
        if (intercepted) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    /* ---------- Initialisation ---------- */
    const checked = block.querySelector('input[name="sizeMode"]:checked')?.value || 'standard';
    setMode(checked);
    console.log('[Surmesure] bloc initialisé ✅');
  });
}

/* ---------- Observation dynamique ---------- */
const observer = new MutationObserver(setupSurMesure);
observer.observe(document.body, { childList: true, subtree: true });
document.addEventListener('DOMContentLoaded', setupSurMesure);
